import React, { useState } from 'react'
import { Link } from 'react-router-dom'

import { CognitoUser, CognitoUserPool } from 'amazon-cognito-identity-js'

import { COGNITO_CLIENT_ID, COGNITO_POOL_ID } from '../utils/Constants'

const ForgotPassword = () => {
  const [email, setEmail] = useState('')
  const [error, setError] = useState(null)
  const [loading, setLoading] = useState(false)
  const [success, setSuccess] = useState(false) // eslint-disable-line no-unused-vars

  const handleSubmit = async e => {
    e.preventDefault()
    setError(null)
    setLoading(true)

    const poolData = {
      UserPoolId: COGNITO_POOL_ID,
      ClientId: COGNITO_CLIENT_ID,
    }
    const userPool = new CognitoUserPool(poolData)
    const userData = {
      Username: email,
      Pool: userPool,
    }
    const cognitoUser = new CognitoUser(userData)

    cognitoUser.forgotPassword({
      onSuccess: function (data) {
        setSuccess(true)
        setLoading(false)
        // Redirect logic can be handled here or by the user clicking a link
        // For better UX, we might want to auto-redirect or show a link
        window.location.href = `/reset-password?email=${encodeURIComponent(email)}`
      },
      onFailure: function (err) {
        setError(err.message || 'Failed to initiate password reset')
        setLoading(false)
      },
    })
  }

  return (
    <div className="container mt-5">
      <div className="row justify-content-center">
        <div className="col-md-6 col-lg-4">
          <div className="card shadow-sm">
            <div className="card-body p-4">
              <div className="text-center mb-4">
                <h3 className="mb-1">Forgot Password</h3>
                <p className="text-muted">Enter your email to reset your password</p>
              </div>

              {error && (
                <div className="alert alert-danger" role="alert">
                  {error}
                </div>
              )}

              <form onSubmit={handleSubmit}>
                <div className="form-group mb-4">
                  <label htmlFor="email">Email address</label>
                  <input
                    type="email"
                    className="form-control"
                    id="email"
                    placeholder="Enter email"
                    value={email}
                    onChange={e => setEmail(e.target.value)}
                    required
                  />
                </div>
                <button type="submit" className="btn btn-primary btn-block w-100" disabled={loading}>
                  {loading ? 'Sending Code...' : 'Send Reset Code'}
                </button>
              </form>

              <div className="text-center mt-3">
                <Link to="/signin">Back to Sign In</Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ForgotPassword
